import { useQuery } from '@tanstack/react-query';
import { authService } from '@/services/authService';

export const useCurrentUser = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: () => authService.getCurrentUser().then(res => res.data),
    enabled: enabled, // Remove sessionStorage check - let AuthContext control via hasToken
    retry: false,
  });
};
